import { useEffect, useRef } from 'react';
import { ContentPageAPI } from 'src/shared/services/api/contentPageAPI';
import { useMutation, useQueryClient } from '@tanstack/react-query';

type UseLogContentViewArgs = {
  contentPageId?: number;
  enabled?: boolean;
  source?: 'web' | 'mobile';
  onLogged?: () => void;
};

export const useLogContentView = ({
  contentPageId,
  enabled = true,
  source = 'web',
  onLogged,
}: UseLogContentViewArgs) => {
  const lastLoggedIdRef = useRef<number | undefined>(undefined);
  const queryClient = useQueryClient();
  const { mutate } = useMutation({
    mutationFn: async (id: number) => {
      const contentApi = new ContentPageAPI();
      return contentApi.LogViewV2(id, source);
    },
    onSuccess: (_data, id) => {
      queryClient.invalidateQueries({ queryKey: ['contentStats', id] });
      onLogged?.();
    },
  });

  useEffect(() => {
    if (!enabled || !contentPageId) return;
    if (lastLoggedIdRef.current === contentPageId) return;
    lastLoggedIdRef.current = contentPageId;
    mutate(contentPageId);
  }, [contentPageId, enabled, mutate]);
};

useLogContentView.defaultProps = {
  enabled: true,
  source: 'web',
  onLogged: undefined,
};
